export default __webpack_public_path__ + "img/tremors/tremors_logo.webp";